import { ILineStyle } from "../../../../base/domain/drawing";
import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";

export interface ILineStylePropertyEditable {
  lineStyle(): IPropertyEditable<ILineStyle>;
}

export function instanceOfILineStylePropertyEditable(instance: any): instance is ILineStylePropertyEditable {
  return instance
      && instance.lineStyle
      && instanceOfIPropertyEditable<ILineStyle>(instance.lineStyle());
}
